<template>
  <v-dialog v-model="dialog" max-width="350">
    <v-card>
      <v-card-title class="headline">Exportar totalizadores</v-card-title>
      <v-card-text class="pt-4">
        <template v-if="loading">
          <v-progress-circular
            class="mr-2"
            size="24"
            width="3"
            indeterminate
            color="primary"
          ></v-progress-circular>
          Buscando informações
        </template>
        <template v-else>
          <template v-if="fundraisingOptions.length > 1">
            Escolha as arrecadações que você quer exportar:
            <v-checkbox
              v-for="option in fundraisingOptions"
              :key="option.value"
              :value="option.value"
              :label="option.text"
              v-model="selectedFundraisings"
              color="primary"
              class="pa-0"
              hide-details
            ></v-checkbox>
            <br />
            <!-- <b>Adicionar abas de totais</b>
            <v-checkbox
              label="Valores pagos"
              v-model="totalPaid"
              color="primary"
              class="pa-0"
              hide-details
            ></v-checkbox>
            <v-checkbox
              label="Valores atrasados"
              v-model="totalLate"
              color="primary"
              class="pa-0"
              hide-details
            ></v-checkbox>
            <br /> -->
          </template>
          <v-btn :disabled="selectedFundraisings.length === 0" color="primary" @click="downloadSheet()">
            <v-icon left>mdi-file-excel-outline</v-icon> Baixar planilha
          </v-btn>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import XLSX from 'xlsx'
import { mapMutations } from 'vuex'

export default {
  name: 'excelExportFundraising',
  props: {
    fundraisings: {
      required: true,
      type: Array
    },
    visible: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({
    dialog: false,
    loading: false,
    fundraisingOptions: [],
    fundraisingData: {},
    selectedFundraisings: [],
    totalPaid: false,
    totalLate: false
  }),
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    getData () {
      this.loading = true
      this.fundraisingOptions = []
      this.fundraisingData = {}
      this.selectedFundraisings = []
      let promises = []
      for (const key in this.fundraisings) {
        const id = this.fundraisings[key]
        promises.push(new Promise((resolve) => {
          resolve()
          axios.get('fundraisings/' + id)
            .then(response => {
              if (response && response.data) {
                const participants = [[
                  'Joined ID',
                  'Nome',
                  'CPF/CNPJ',
                  'Entrou em',
                  'Total',
                  'Qtd Parcelas restantes',
                  'Total Pago',
                  'Pago por fora',
                  'Pago pela Heppi (sem juros)',
                  'Juros pago',
                  'Atrasado (sem juros)'
                ]]
                for (const index in response.data.participants) {
                  const participant = response.data.participants[index]
                  participants.push([
                    participant.joined_id,
                    participant.name,
                    participant.person_document,
                    this.$moment(participant.joined_created_at, 'YYYY-MM-DD HH:mm').format('MM/YYYY'),
                    participant.amount_to_pay,
                    participant.number_of_installment || 0,
                    participant.total_paid,
                    participant.total_paid_before,
                    participant.total_paid_without_interest_and_fine,
                    participant.total_paid_interest_and_fine,
                    participant.total_late
                  ])
                }
                this.fundraisingData[id] = { name: response.data.name, participants }
                this.fundraisingOptions.push({ value: id, text: response.data.name })
                this.selectedFundraisings.push(id)
              }
            })
            .finally(() => {
              resolve()
            })
        }))
      }
      Promise.all(promises)
        .finally(() => { this.loading = false })
    },
    downloadSheet () {
      const workbook = XLSX.utils.book_new()
      for (const key in this.selectedFundraisings) {
        const id = this.selectedFundraisings[key]
        // console.log(this.fundraisingData[id].participants)
        const ws = XLSX.utils.aoa_to_sheet(this.fundraisingData[id].participants)
        const name = this.fundraisingData[id].name.replace(/[^\w\s]/gi, '')
        XLSX.utils.book_append_sheet(workbook, ws, name)
      }
      XLSX.writeFile(workbook, 'totalizadores.xlsx')
    }
  },
  watch: {
    visible (val) {
      this.dialog = !!val
      if (val) this.getData()
    },
    dialog (val) {
      if (!val) this.$emit('close')
    }
  }
}
</script>
